import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import {Avatar, Dropdown, Menu, Modal, Tag} from 'antd';
import {useNavigate} from 'react-router-dom';
import _ from 'lodash';
import classNames from 'classnames';
import {ApartmentOutlined, LockOutlined, LogoutOutlined, UserOutlined, SyncOutlined, ProfileOutlined} from '@/icons';
import {isAzureAuth, isDefaultAuth} from '@/app/AuthUtils';
import CorpSwitch from '@/page/component/corp/CorpSwitch';
import {getStorageCorps} from '@/util/AuthStore';
import {getCurrentCorpName} from '@/page/component/corp/storageCorp';

import styles from './UserAvatar.module.less';
import {useAuthStore} from '@/context/auth';
import {changeLayout} from '@/util/AuthStore';

UserAvatar.propTypes = {
    avatarClassName: PropTypes.string,
};

function UserAvatar({avatarClassName}) {
    const corpSwitchRef = useRef();
    const navigate = useNavigate();

    const [authStore, dispatch] = useAuthStore();

    const storageCorpData = getStorageCorps();
    const currentCorpId = storageCorpData?.cid;
    const corps = storageCorpData?.corps ?? [];
    const showCorpSwitch = currentCorpId && corps.length > 1;
    const userName = _.get(authStore, 'user.name');
    // const userName = _.get(authStore, 'user.name');
    const corpName = getCurrentCorpName();

    function onMenuClick({key}) {
        if (key === 'corpSwitch') {
            corpSwitchRef.current.showModal();
        } else if (key === 'profile') {
            navigate('/profile');
        } else if (key === 'password') {
            navigate('/profile/password');
        } else if (key === 'change') {
            Modal.confirm({
                title: '切换布局',
                content: '确定切换布局？',
                okButtonProps: {
                    danger: true,
                },
                onOk: () => {
                    changeLayout();
                    window.location.reload(true);
                },
            });
        } else if (key === 'logout') {
            Modal.confirm({
                title: '退出系统',
                content: '确定退出当前登录？',
                okButtonProps: {
                    danger: true,
                },
                onOk: () => {
                    navigate('/login');
                },
            });
            // if (isAzureAuth) {
            //     navigate('/logout');
            // }
            // if (isDefaultAuth) {
            //     Modal.confirm({
            //         title: '退出系统',
            //         content: '确定退出当前登录？',
            //         okButtonProps: {
            //             danger: true,
            //         },
            //         onOk: () => {
            //             navigate('/login');
            //         },
            //     });
            // }
        } else if (key === 'docs') {
            navigate('/docs/');
        }
    }

    const menu = (
        <Menu className={styles.menu} onClick={onMenuClick}>
            {showCorpSwitch && (
                <>
                    <Menu.Item key="corpSwitch" icon={<ApartmentOutlined />}>
                        切换企业
                    </Menu.Item>
                    <Menu.Divider />
                </>
            )}
            <Menu.Item key="profile" icon={<UserOutlined />}>
                个人信息
            </Menu.Item>
            {/*<Menu.Item key="password" icon={<LockOutlined />}>*/}
            {/*    修改密码*/}
            {/*</Menu.Item>*/}
            <Menu.Item key="change" icon={<SyncOutlined />}>
                切换布局
            </Menu.Item>
            <Menu.Item key="docs" icon={<ProfileOutlined />}>
                使用文档
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item key="logout" danger icon={<LogoutOutlined />}>
                退出
            </Menu.Item>
        </Menu>
    );

    return (
        <>
            <Dropdown arrow overlay={menu} placement="bottomCenter">
                {/* 这个 div 包装必须保留，否则菜单无法正常显示 */}
                <div>
                    <div className={classNames(styles.avatar, avatarClassName)}>
                        <Avatar>{userName && userName.charAt(0)}</Avatar>
                        <span className={styles.userName}>{userName}</span>
                        {corpName && <Tag color="blue">@{corpName}</Tag>}
                    </div>
                </div>
            </Dropdown>
            <CorpSwitch ref={corpSwitchRef} />
        </>
    );
}

export default UserAvatar;
